<div class="container">
    <div class="row">
        <div class="col">
            <h4>Package - {{selectPackage.packageNumber}}</h4>
        </div>
        <div class="col">
        </div>
        <div class="col">
            <h4>Dealer - {{selectPackage.dealerName}}</h4>
        </div>
    </div>
</div>

<div *ngIf="showInsuranceDetails">
    <button (click)="backToSearch()" class="btn btn-sm btn-success mb-2">Back To Search Screen</button>

    <div class="content-card">
        <div class="card-section-header">
            <i class="fa fa-car"></i> Insurance Details
        </div>
        <div class="card-section-body">
            <div class="row">
                <div class="col">
                    <dl class="mb-0">
                        <dt>{{isCorporate?"Organisation Name":"Name"}}</dt>
                        <dd class="text-muted">{{selectPackage.firstName + " " + selectPackage.lastName}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>{{isCorporate?"Organisation Address":"First Address"}}</dt>
                        <dd class="text-muted">{{selectPackage.address}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>State</dt>
                        <dd class="text-muted">{{selectPackage.state}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>City</dt>
                        <dd class="text-muted">{{selectPackage.city}}</dd>
                    </dl>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <dl class="mb-0">
                        <dt>Pincode</dt>
                        <dd class="text-muted">{{selectPackage.pincode}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt *ngIf="!isCorporate">Aadhar Number</dt>
                        <dt *ngIf="isCorporate">GST Number</dt>
                        <dd class="text-muted">{{selectPackage.aadhaarNumber}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>{{isCorporate?"Organisation Email":"Email"}}</dt>
                        <dd class="text-muted">{{selectPackage.email}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Contact Number</dt>
                        <dd class="text-muted">{{selectPackage.contactNumber}}</dd>
                    </dl>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <dl class="mb-0">
                        <dt>Vehicle Code</dt>
                        <dd class="text-muted">{{selectPackage.dealerModelPrice && selectPackage.dealerModelPrice.orientalVariantCode ? selectPackage.dealerModelPrice.orientalVariantCode : selectPackage.model}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Vehicle Type</dt>
                        <dd class="text-muted">{{selectPackage.type == "New"?"W":""}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Vehicle Class</dt>
                        <dd class="text-muted">CLASS_3</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>IDV</dt>
                        <dd class="text-muted">{{selectPackage.idv}}</dd>
                    </dl>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <dl class="mb-0">
                        <dt>Risk Start Date (YYYY-MM-DD)</dt>
                        <dd class="text-muted">{{selectPackage.startDate| date:'dd-MM-yyyy':'+0530'}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>RTO</dt>
                        <dd class="text-muted">{{selectPackage.rto}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Engine Number</dt>
                        <dd class="text-muted">{{selectPackage.engineNumber}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Chasis Number</dt>
                        <dd class="text-muted">{{selectPackage.chasisNumber}}</dd>
                    </dl>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <dl class="mb-0">
                        <dt>Vehicle Color</dt>
                        <dd class="text-muted">{{selectPackage.vehicleColor ? selectPackage.vehicleColor : "As Per Invoice"}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Nil Dep</dt>
                        <dd class="text-muted">{{selectPackage.nilDep}}</dd>
                    </dl>
                </div>
                <div class="col" *ngIf="selectPackage.type == 'Old'">
                    <dl class="mb-0">
                        <dt>Vehicle Registration Date(DD/MM/YYYY)</dt>
                        <dd class="text-muted">{{('0' + selectPackage.vehicleRegistrationDate.day).slice(-2) + "/" + ('0' + selectPackage.vehicleRegistrationDate.month).slice(-2) + "/" + selectPackage.vehicleRegistrationDate.year}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>RTI Cover</dt>
                        <dd class="text-muted">{{selectPackage.rtiCover}}</dd>
                    </dl>
                </div>
                <div class="col" *ngIf="selectPackage.type == 'New'">
                </div>
            </div>
            <div class="row" *ngIf="selectPackage.financeCompanyName">
                <div class="col">
                    <dl class="mb-0">
                        <dt>Hypothication Co State</dt>
                        <dd class="text-muted">{{selectPackage.financeCompanyState ? selectPackage.financeCompanyState : ""}}</dd>
                    </dl>
                </div>
                <div class="col">
                    <dl class="mb-0">
                        <dt>Hypothication Co City</dt>
                        <dd class="text-muted">{{selectPackage.financeCompanyCity ? selectPackage.financeCompanyCity: ""}}</dd>
                    </dl>
                </div>
                <div class="col" *ngIf="selectPackage.financeCompanyName">
                    <dl class="mb-0">
                        <dt>Hypothication Co Name</dt>
                        <dd class="text-muted">{{selectPackage.financeCompanyName}}</dd>
                    </dl>
                </div>
                <div class="col" *ngIf="selectPackage.financeCompanyAddress">
                    <dl class="mb-0">
                        <dt>Hypothication Co Address</dt>
                        <dd class="text-muted">{{selectPackage.financeCompanyAddress}}</dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-card">
    <div class="card-section-header">
        <i class="fa fa-car"></i> Vehicle Details
    </div>
    <div class="card-section-body">
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>Vehicle Type</dt>
                    <dd class="text-muted">{{selectPackage.type}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Vehicle Make</dt>
                    <dd class="text-muted">{{selectPackage.vehicleMake}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Model</dt>
                    <dd class="text-muted">{{selectPackage.model}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Variant</dt>
                    <dd class="text-muted">{{selectPackage.variant}}</dd>
                </dl>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>Manufacturing Year</dt>
                    <dd class="text-muted">{{selectPackage.vehicleYear}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Registration Number</dt>
                    <dd class="text-muted">{{selectPackage.registrationNumber}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Chasis Number</dt>
                    <dd class="text-muted">{{selectPackage.chasisNumber}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Engine Number</dt>
                    <dd class="text-muted">{{selectPackage.engineNumber}}</dd>
                </dl>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>RTO</dt>
                    <dd class="text-muted">{{selectPackage.rto}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Hypothecated?</dt>
                    <dd class="text-muted">{{selectPackage.hypothecated}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.financeCompanyName">
                <dl class="mb-0">
                    <dt>Finance Company</dt>
                    <dd class="text-muted">{{selectPackage.financeCompanyName}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.financeCompanyAddress">
                <dl class="mb-0">
                    <dt>Finance Company Address</dt>
                    <dd class="text-muted">{{selectPackage.financeCompanyAddress}}</dd>
                </dl>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <img *ngIf="invoiceImageSrc" [src]="invoiceImageSrc" class="card-img-top img-fluid" alt="Invoice document" style="max-height: 200px; object-fit: contain;">
                    <div class="card-body">
                      <h5 class="card-title">Invoice</h5>
                      <a href="javascript:void(0);" (click)="downloadImage('invoice')" *ngIf="invoiceImageSrc">Download</a>
                    </div>
                </div>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>{{selectPackage.oldValueType && selectPackage.oldValueType =='PrevIdv'?"Previous Year IDV":"Invoice Amount"}}</dt>
                    <dd class="text-muted">{{selectPackage.invoiceValue}}</dd>
                </dl>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>Cubic Capacity</dt>
                    <dd class="text-muted">{{selectPackage.cubicCapacity}}</dd>
                </dl>
            </div>
        </div>
    </div>
</div>

<div class="content-card">
    <div class="card-section-header">
        <i class="fa fa-book"></i> Package Details
    </div>
    <div class="card-section-body">
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>Package Name</dt>
                    <dd class="text-muted">{{selectPackage.package.packageName}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.type !='Old'">
                <dl class="mb-0">
                    <dt>Invoice Value &amp; Accessories cost</dt>
                    <dd class="text-muted">{{selectPackage.idv}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.type =='Old'">
                <dl class="mb-0">
                    <dt>Previous Policy Expired</dt>
                    <dd class="text-muted">{{selectPackage.prevPolicyExpire}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Nil Depreciation</dt>
                    <dd class="text-muted">{{selectPackage.nilDep}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Estimate Insurance Cost</dt>
                    <dd class="text-muted">{{selectPackage.estimatedPolicyTotalAmount && selectPackage.estimatedPolicyTotalAmount > 0?selectPackage.estimatedPolicyTotalAmount:selectPackage.packagePolicyTotalAmount}}</dd>
                </dl>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>Risk Start Date (YYYY-MM-DD)</dt>
                    <dd class="text-muted">{{selectPackage.startDate| date:'dd-MM-yyyy hh:mm:ss a':'+0530'}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.type !='Old'">
                <dl class="mb-0">
                    <dt>RTI Cover</dt>
                    <dd class="text-muted">{{selectPackage.rtiCover}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.type !='Old'"></div>
            <div class="col" *ngIf="selectPackage.type !='Old'"></div>
            <div class="col" *ngIf="selectPackage.type =='Old'">
                <dl class="mb-0">
                    <dt>Previous Policy Claim</dt>
                    <dd class="text-muted">{{selectPackage.prePolClaim}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.type =='Old'">
                <dl class="mb-0">
                    <dt>Claim Year</dt>
                    <dd class="text-muted">{{claimYear}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="selectPackage.type =='Old'">
                <dl class="mb-0">
                    <dt>Transfer Case</dt>
                    <dd class="text-muted">{{selectPackage.transferCase}}</dd>
                </dl>
            </div>
        </div>
        <div class="row" *ngIf="selectPackage.package.prevInsuranceDetailShow.includes('GetODDetails')">
            <div class="col">
                <dl class="mb-0">
                    <dt>Previous OD Insurer</dt>
                    <dd class="text-muted">{{selectPackage.prevOdInsurer}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Previous OD Policy Number</dt>
                    <dd class="text-muted">{{selectPackage.prevOdPolicyNo}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Previous OD Policy Expiry Date</dt>
                    <dd class="text-muted">{{(selectPackage.prevOdPolicyExpiry.day < 10?"0" + selectPackage.prevOdPolicyExpiry.day: selectPackage.prevOdPolicyExpiry.day) + "/" + (selectPackage.prevOdPolicyExpiry.month < 10?"0" + selectPackage.prevOdPolicyExpiry.month: selectPackage.prevOdPolicyExpiry.month) + "/" + selectPackage.prevOdPolicyExpiry.year }}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>RTI Cover</dt>
                    <dd class="text-muted">{{selectPackage.rtiCover}}</dd>
                </dl>
            </div>
        </div>
        <div class="row" *ngIf="selectPackage.package.prevInsuranceDetailShow.includes('GetTPDetails')">
            <div class="col">
                <dl class="mb-0">
                    <dt>Previous TP Insurer</dt>
                    <dd class="text-muted">{{selectPackage.prevTpInsurer}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Previous TP Policy Number</dt>
                    <dd class="text-muted">{{selectPackage.prevTpPolicyNo}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Previous TP Policy Expiry Date</dt>
                    <dd class="text-muted">{{(selectPackage.prevTpPolicyExpiry.day < 10?"0" + selectPackage.prevTpPolicyExpiry.day: selectPackage.prevTpPolicyExpiry.day) + "/" + (selectPackage.prevTpPolicyExpiry.month < 10?"0" + selectPackage.prevTpPolicyExpiry.month: selectPackage.prevTpPolicyExpiry.month) + "/" + selectPackage.prevTpPolicyExpiry.year }}</dd>
                </dl>
            </div>
            <div class="col"></div>
        </div>
    </div>
</div>

<div class="content-card" *ngIf="selectPackage.breakInspectionReportNumber">
    <div class="card-section-header">
        <i class="fa fa-book"></i> Inspection Details
    </div>
    <div class="card-section-body">
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>Inspection Number</dt>
                    <dd class="text-muted">{{selectPackage.breakInspectionReportNumber}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Inspection Date</dt>
                    <dd class="text-muted">{{selectPackage.breakInspectionReportDate}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Inspection Time</dt>
                    <dd class="text-muted">{{selectPackage.breakInspectionReportTime}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Inspection Report</dt>
                    <dd>
                        <div class="card">
                            <img *ngIf="breakInspectionReportImageSrc" [src]="breakInspectionReportImageSrc" class="card-img-top img-fluid" alt="Break inspection report" style="max-height: 200px; object-fit: contain;">
                            <div class="card-body">
                                <h5 class="card-title">Inspection Report</h5>
                                <a href="javascript:void(0);" (click)="downloadImage('breakInspectionReport')">{{selectPackage.breakInspectionReportNumber}}</a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</div>

<div class="content-card" *ngIf="user.role == 'admin'">
    <div class="card-section-header">
        <i class="fa fa-user"></i> Premium Calculation
    </div>
    <div class="card-section-body">
        <div *ngIf="selectPackage.type == 'New'">
            <h5 class="mb-2">Insurance Policy Amount</h5>
            <div class="row">
                <div class="col"><h6>Policy Amount:</h6></div>
                <div class="col text-end"><h6 class="text-muted">{{selectPackage.insurancePolicyAmount? selectPackage.insurancePolicyAmount.toFixed(2): 0.00}}</h6></div>
            </div>
            <div class="row">
                <div class="col"><h6>GST Amount:</h6></div>
                <div class="col text-end"><h6 class="text-muted">{{selectPackage.insurancePolicyGStAmount? selectPackage.insurancePolicyGStAmount.toFixed(2): 0.00}}</h6></div>
            </div>
            <div class="row">
                <div class="col"><h6>Total Plan Amount:</h6></div>
                <div class="col text-end"><h6 class="text-muted">{{selectPackage.insurancePolicyTotalAmount? selectPackage.insurancePolicyTotalAmount.toFixed(2): 0.00}}</h6></div>
            </div>
            <h5 class="mb-2 mt-3">CPA Amount</h5>
            <div class="row">
                <div class="col"><h6>Plan Amount:</h6></div>
                <div class="col text-end"><h6 class="text-muted">{{selectPackage.planAmount? selectPackage.planAmount.toFixed(2): 0.00}}</h6></div>
            </div>
            <div class="row">
                <div class="col"><h6>GST Amount:</h6></div>
                <div class="col text-end"><h6 class="text-muted">{{selectPackage.planGSTAmount? selectPackage.planGSTAmount.toFixed(2): 0.00}}</h6></div>
            </div>
            <div class="row">
                <div class="col"><h6>Total Plan Amount:</h6></div>
                <div class="col text-end"><h6 class="text-muted">{{selectPackage.planTotalAmount? selectPackage.planTotalAmount.toFixed(2): 0.00}}</h6></div>
            </div>
            <h5 class="mb-2 mt-3">Summary</h5>
            <div class="row">
                <div class="col"><h5>Total Calculated Amount(Actual Amount Charged):</h5></div>
                <div class="col text-end"><h6>{{selectPackage.packagePolicyTotalAmount ? selectPackage.packagePolicyTotalAmount.toFixed(2):0.00}}</h6></div>
            </div>
            <div class="row">
                <div class="col"><h5>Total Estimated Amount(Shown to Dealer):</h5></div>
                <div class="col text-end"><h6>{{selectPackage.estimatedPolicyTotalAmount? selectPackage.estimatedPolicyTotalAmount.toFixed(2):0.00}}</h6></div>
            </div>
            <div class="row">
                <div class="col"><h5>Difference(Total Calculated Amount - Total Package Amount):</h5></div>
                <div class="col text-end"><h6>{{((selectPackage.packagePolicyTotalAmount ? selectPackage.packagePolicyTotalAmount:0.00) - (selectPackage.estimatedPolicyTotalAmount? selectPackage.estimatedPolicyTotalAmount:0.00) ).toFixed(2)}}</h6></div>
            </div>
        </div>
    </div>
</div>

<div class="content-card" *ngIf="selectPackage.type == 'Old' && ['admin','employee'].includes(user.role)">
    <div class="card-section-header">
        <i class="fa fa-user"></i> Premium Calculation (Old Vehicle)
    </div>
    <div class="card-section-body">
        <h5 class="mb-2">OD Premium Calculation</h5>
        <div class="row">
            <div class="col"><h6>OD Premium Amount({{selectPackage.odPremiumRate}}):</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.odPremiumAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h6>OD Discount({{selectPackage.odDiscountPercentage}}):</h6></div>
            <div class="col text-end"><h6 class="text-muted">-{{selectPackage.odDiscountAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h6>NCB Discount({{selectPackage.odNCBPercentage}}):</h6></div>
            <div class="col text-end"><h6 class="text-muted">-{{selectPackage.odNCBAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h6>Nil Dep Cover Amount({{selectPackage.nilDepPercentage}}):</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.nilDepAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h6>RTI Cover Amount({{selectPackage.rtiCoverPercentage}}):</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.rtiCoverAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h5>Total OD Premium Amount:</h5></div>
            <div class="col text-end"><h6>{{(selectPackage.odPremiumAmount - selectPackage.odDiscountAmount -selectPackage.odNCBAmount + selectPackage.nilDepAmount + selectPackage.rtiCoverAmount ).toFixed(2)}}</h6></div>
        </div>
        <h5 class="mb-2 mt-3">TP Premium Calculation</h5>
        <div class="row">
            <div class="col"><h6>TP Premium Amount:</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.tpPremiumAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h6>CPA Cover Amount ({{selectPackage.cpaCoverPlanName}}):</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.CpaCoverAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h6>TPPD Cover Amount:</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.tpPdCoverAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h5>Total TP Premium Amount:</h5></div>
            <div class="col text-end"><h6>{{(selectPackage.tpPremiumAmount + selectPackage.CpaCoverAmount + selectPackage.tpPdCoverAmount ).toFixed(2)}}</h6></div>
        </div>
        <h5 class="mb-2 mt-3">Summary</h5>
        <div class="row">
            <div class="col"><h6>Total GST Amount:</h6></div>
            <div class="col text-end"><h6 class="text-muted">{{selectPackage.totalGstAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h5>Total Calculated Amount(Shown to Dealer):</h5></div>
            <div class="col text-end"><h6>{{(selectPackage.tpPremiumAmount + selectPackage.CpaCoverAmount + selectPackage.tpPdCoverAmount + selectPackage.totalGstAmount + selectPackage.odPremiumAmount - selectPackage.odDiscountAmount -selectPackage.odNCBAmount + selectPackage.nilDepAmount + selectPackage.rtiCoverAmount ).toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h5>Total Package Amount(Actual Amount Charged):</h5></div>
            <div class="col text-end"><h6>{{selectPackage.packagePolicyTotalAmount.toFixed(2)}}</h6></div>
        </div>
        <div class="row">
            <div class="col"><h5>Difference(Total Calculated Amount - Total Package Amount):</h5></div>
            <div class="col text-end"><h6>{{(selectPackage.tpPremiumAmount + selectPackage.CpaCoverAmount + selectPackage.tpPdCoverAmount + selectPackage.totalGstAmount + selectPackage.odPremiumAmount - selectPackage.odDiscountAmount -selectPackage.odNCBAmount + selectPackage.nilDepAmount + selectPackage.rtiCoverAmount - selectPackage.packagePolicyTotalAmount ).toFixed(2)}}</h6></div>
        </div>
    </div>
</div>

<div class="content-card">
    <div class="card-section-header">
        <i class="fa fa-user"></i> KYC Details
    </div>
    <div class="card-section-body">
        <div class="row">
            <div class="col">
                <div class="card">
                    <img *ngIf="panImageSrc" [src]="panImageSrc" class="card-img-top img-fluid" alt="PAN card document" style="max-height: 200px; object-fit: contain;">
                    <div class="card-body">
                        <h5 class="card-title">PAN Number</h5>
                        <a href="javascript:void(0);" (click)="downloadImage('pan')">{{selectPackage.panNumber}}</a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <img *ngIf="aadhaarImageSrc" [src]="aadhaarImageSrc" class="card-img-top img-fluid" alt="Aadhaar card document" style="max-height: 200px; object-fit: contain;">
                    <div class="card-body">
                        <h5 class="card-title" *ngIf="!isCorporate">Aadhaar Number: {{selectPackage.aadhaarNumber}}</h5>
                        <h5 class="card-title" *ngIf="isCorporate">GST Number: {{selectPackage.aadhaarNumber}}</h5>
                        <a (click)="downloadImage('aadhaar')" href="javascript:void(0);" *ngIf="aadhaarImageSrc">{{selectPackage.aadhaarNumber}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-card">
    <div class="card-section-header">
        <i class="fa fa-user"></i>
        <span *ngIf="!isCorporate"> Customer Details</span>
        <span *ngIf="isCorporate"> Corporate Details</span>
    </div>
    <div class="card-section-body">
        <div class="row">
            <div class="col" *ngIf="!isCorporate">
                <dl class="mb-0">
                    <dt>Title</dt>
                    <dd class="text-muted">{{selectPackage.title?selectPackage.title:''}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>{{isCorporate?"Organisation Name":"First Name"}}</dt>
                    <dd class="text-muted">{{selectPackage.firstName}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="!isCorporate">
                <dl class="mb-0">
                    <dt>Last Name</dt>
                    <dd class="text-muted">{{selectPackage.lastName}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>{{isCorporate?"Organisation Email":"Email"}}</dt>
                    <dd class="text-muted">{{selectPackage.email}}</dd>
                </dl>
            </div>
        </div>
        <div class="row">
            <div class="col" *ngIf="!isCorporate">
                <dl class="mb-0">
                    <dt>Gender</dt>
                    <dd class="text-muted">{{selectPackage.gender}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="!isCorporate">
                <dl class="mb-0">
                    <dt>Date of Birth</dt>
                    <dd class="text-muted">{{selectPackage.dob}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Contact Number</dt>
                    <dd class="text-muted">{{selectPackage.contactNumber}}</dd>
                </dl>
            </div>
            <div class="col"></div>
            <div class="col" *ngIf="isCorporate"></div>
            <div class="col" *ngIf="isCorporate"></div>
        </div>
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>{{isCorporate?"Organisation Address":"First Address"}}</dt>
                    <dd class="text-muted">{{selectPackage.address}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>State</dt>
                    <dd class="text-muted">{{selectPackage.state}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>City</dt>
                    <dd class="text-muted">{{selectPackage.city}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>Pincode</dt>
                    <dd class="text-muted">{{selectPackage.pincode}}</dd>
                </dl>
            </div>
        </div>
    </div>
</div>

<div class="content-card">
    <div class="card-section-header">
        <i class="fa fa-user"></i>
        <span *ngIf="!isCorporate"> Nominee Details</span>
        <span *ngIf="isCorporate"> Contact Person Details</span>
    </div>
    <div class="card-section-body">
        <div class="row">
            <div class="col">
                <dl class="mb-0">
                    <dt>{{isCorporate?"Name":"Nominee Name"}}</dt>
                    <dd class="text-muted">{{selectPackage.nomineeName}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>{{isCorporate?"Gender":"Nominee Gender"}}</dt>
                    <dd class="text-muted">{{selectPackage.nomineeGender}}</dd>
                </dl>
            </div>
            <div class="col">
                <dl class="mb-0">
                    <dt>{{isCorporate?"Age":"Nominee Age"}}</dt>
                    <dd class="text-muted">{{selectPackage.nomineeAge}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="!isCorporate">
                <dl class="mb-0">
                    <dt>Nominee Relationship</dt>
                    <dd class="text-muted">{{selectPackage.nomineeRelationship}}</dd>
                </dl>
            </div>
            <div class="col" *ngIf="isCorporate">
                <dl class="mb-0">
                    <dt>Contact Number</dt>
                    <dd class="text-muted">{{selectPackage.employeeContactNumber}}</dd>
                </dl>
            </div>
        </div>
    </div>
</div>
